import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 7a3 3 0 0 1 3 3v4a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-4a3 3 0 0 1 3 -3z","key":"svg-0"}]]

/**
 * IconCrop169Filled
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0iY3VycmVudENvbG9yIgogIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb25zLXRhYmxlci1maWxsZWQgaWNvbi10YWJsZXItY3JvcC0xNi05Igo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xOCA3YTMgMyAwIDAgMSAzIDN2NGEzIDMgMCAwIDEgLTMgM2gtMTJhMyAzIDAgMCAxIC0zIC0zdi00YTMgMyAwIDAgMSAzIC0zeiIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/crop-16-9-filled
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCrop169Filled = createReactComponent('filled', 'crop-16-9-filled', 'Crop169Filled', __iconNode);

export default IconCrop169Filled;